import React from 'react';

const Widget = ({ title, className = '', children }) => (
    <div className={`${className}`} style={{ flex: 1 }}>
        {/* <h3>{title}</h3> */}
        {children}
    </div>
);

export default Widget;
